define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var PlanItemModel = /** @class */ (function () {
        function PlanItemModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.BillItemName = ko.observable();
            this.BillItemDesc = ko.observable();
            this.CallPlanId = ko.observable(0);
            //CallType = ko.observable<string>();
            this.CallTypes = ko.observableArray();
            this.AdditionalCallTypes = ko.observableArray();
            this.RateType = ko.observable();
            this.SplitByNumber = ko.observable(false);
            this.IsFlat = ko.observable(true);
            this.Rate = ko.observable(0);
            this.RateFormat = ko.observable("c5");
            this.StartRange = ko.observable(0);
            this.EndRange = ko.observable(0);
            this.IsDeleted = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, PlanItemModel.Mapping, self);
            }
            if (self.IsFlat()) {
                if (self.RateType() === "6") {
                    self.RateFormat("n1");
                }
                else {
                    self.RateFormat("c5");
                }
            }
            else {
                if (self.RateType() === "6") {
                    self.RateFormat("c1");
                }
                else {
                    self.RateFormat("p1");
                }
            }
            self.RateType.subscribe(function (value) {
                if (self.IsFlat()) {
                    if (self.RateType() === "6") {
                        self.RateFormat("n1");
                        self.Rate(self.Rate() * 1);
                    }
                    else {
                        self.RateFormat("c5");
                        self.Rate(self.Rate() * 1);
                    }
                }
                else {
                    if (self.RateType() === "6") {
                        self.RateFormat("c1");
                        self.Rate(self.Rate() * 1);
                    }
                    else {
                        self.RateFormat("p1");
                        self.Rate(self.Rate() / 1);
                    }
                }
            });
            self.IsFlat.subscribe(function (value) {
                if (value) {
                    if (self.RateType() === "6") {
                        self.RateFormat("n1");
                        self.Rate(self.Rate() * 1);
                    }
                    else {
                        self.RateFormat("c5");
                        self.Rate(self.Rate() * 1);
                    }
                }
                else {
                    if (self.RateType() === "6") {
                        self.RateFormat("c1");
                        self.Rate(self.Rate() * 1);
                    }
                    else {
                        self.RateFormat("p1");
                        self.Rate(self.Rate() / 1);
                    }
                }
            });
        }
        PlanItemModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new PlanItemModel(options.data);
            }
        };
        return PlanItemModel;
    }());
    return PlanItemModel;
});
//# sourceMappingURL=PlanItemModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/PlanItemModel.js
// module id = 221
// module chunks = 2